import { Outlet } from 'react-router-dom'

const ClientsWrapper = () => {
  return (
    <div className="flex-1 flex flex-col px-[24px] pb-[24px]">
      <Outlet />
    </div>
  )
}

export default ClientsWrapper
